import React, {Component} from 'react';
import {PropTypes} from 'prop-types';
import * as messageConstants from '../../../shared/messages';
import ClaimsRow from "./ClaimsRow";
import {NEW_OIDC_CLAIM} from "../../../constants/oidcConstants";
import {ACCESS_TOKEN, ID_TOKEN} from "../../../shared/messages";
import "./Claims.scss";

class ClaimsTable extends Component {
    static propTypes = {
        displayFlexibleAttributes: PropTypes.bool,
        displayUserExtendedAttributes: PropTypes.bool,
        displayNonLdapEpicUsername: PropTypes.bool,
        extendedAttributes: PropTypes.object,
        updateClaimsInScope: PropTypes.func,
        oidcCustomClaims: PropTypes.array,
    }

    handleAddClaimToScope = () => {
        var updatedCustomClaims = [...this.props.oidcCustomClaims, NEW_OIDC_CLAIM];
        this.props.updateClaimsInScope(updatedCustomClaims);
    }
    handleUpdateClaimInScope = (updatedClaimIndex, updatedClaim) => {
        var updatedCustomClaims = this.props.oidcCustomClaims.map((customClaim, index) => {
            if (index === updatedClaimIndex) {
                return updatedClaim
            }
            return customClaim;
        });
        this.props.updateClaimsInScope(updatedCustomClaims);
    }
    handleDeleteClaimFromScope = (claimToDeleteIndex, claimToDelete) => {
        var updatedCustomClaims = this.props.oidcCustomClaims.filter(((customClaim, index) =>
            index !== claimToDeleteIndex || customClaim !== claimToDelete));
        this.props.updateClaimsInScope(updatedCustomClaims);
    }

    render() {
        const claimsRows = this.props.oidcCustomClaims
            ? this.props.oidcCustomClaims.map(
                (oidcCustomClaim, index) =>
                    <ClaimsRow
                        oidcCustomClaim={oidcCustomClaim}
                        extendedAttributes={this.props.extendedAttributes}
                        displayUserExtendedAttributes={this.props.displayUserExtendedAttributes}
                        displayFlexibleAttributes={this.props.displayFlexibleAttributes}
                        displayNonLdapEpicUsername={this.props.displayNonLdapEpicUsername}
                        updateClaimInScope={this.handleUpdateClaimInScope}
                        deleteClaimFromScope={this.handleDeleteClaimFromScope}
                        id={index}
                        key={index}/>
            ) : [];

        return (
            <div className="claim-table">
                <table>
                    <tbody>
                    {claimsRows.length > 0 ? <tr>
                        <th className="claim-name-title">
                            {messageConstants.CLAIM_NAME}
                        </th>
                        <th className="claim-attribute-dropdown-title pl-12">
                            {messageConstants.CLAIM_ATTRIBUTE_MAPPING}
                        </th>
                        <th/>
                        <th className="claim-checkbox-title">{ID_TOKEN}</th>
                        <th className="claim-checkbox-title">{ACCESS_TOKEN}</th>
                    </tr> : null}
                    {claimsRows}
                    <tr>
                        <td className="add-attribute">
                            <button type="button" onClick={this.handleAddClaimToScope} className="attr-button">
                                <span className="fa fa-plus btn-circle btn-plus"/>
                                <span className="attr-button-label">
                                    {messageConstants.BUTTON_ADD_CLAIM}
                                </span>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
            </div>
        );
    }
}

export default ClaimsTable;
